export const dateExceedsToday = (date: string): boolean => {
  const today = new Date();
  return new Date(date) < today;
};
